import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";

import {
	Avatar,
	Button,
	CssBaseline,
	TextField,
	FormControlLabel,
	Checkbox,
	Link,
	Grid,
	Typography,
	makeStyles,
	Container,
	FormControl,
	InputLabel,
	Select,
	Snackbar,
	Alert,
} from "@material-ui/core";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";

import ReactFlagsSelect from "react-flags-select";

import { IUser } from "../../Models/Interfaces/IUser";
import { useAuthStore, useInstitutionStore } from "../../Stores/Stores";
import AuthProvider from "../../Providers/AuthProvider";
import WorkArea from "./WorkArea";

const useStyles = makeStyles((theme) => ({
	paper: {
		marginTop: theme.spacing(8),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: "100%", // Fix IE 11 issue.
		marginTop: theme.spacing(3),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
}));

const Register = () => {
	const classes = useStyles();
	const history = useHistory();
	const authStore = useAuthStore();
	const institutionStore = useInstitutionStore();
	const [fetched, setFetched] = useState(false);
	const [message, setMessage] = useState("");
	const { register, handleSubmit, control } = useForm<IUser>();
	const [workArea, setWorkArea] = React.useState<any>(null);
	const [countryCode, setCountryCode] = React.useState("");
	
	const [agreeButton, setAgreeButton] = useState(false);
	const [personalData, setPersonalData] = React.useState(false);
	const [affiliation, setAffiliation] = React.useState(false);

	const [countryCodeModal, setCountryCodeModal] = React.useState(false);

	const countryCodeID = (code: any) => {
		let countryList = [{"countryId":"1","countryName":"Austria","countryCode":"AT"},{"countryId":"2","countryName":"the Kingdom of Belgium","countryCode":"BE"},{"countryId":"3","countryName":"Bulgaria","countryCode":"BG"},{"countryId":"4","countryName":"Cyprus","countryCode":"CY"},{"countryId":"5","countryName":"the Czech Republic","countryCode":"CZ"},{"countryId":"6","countryName":"the Kingdom of Denmark","countryCode":"DK"},{"countryId":"7","countryName":"the Republic of Estonia","countryCode":"EE"},{"countryId":"8","countryName":"Finlad","countryCode":"FI"},{"countryId":"9","countryName":"French Republic","countryCode":"FR"},{"countryId":"10","countryName":"the Hellenic Republic (Greece)","countryCode":"GR"},{"countryId":"11","countryName":"Croatia","countryCode":"HR"},{"countryId":"12","countryName":"the Republic of Ireland","countryCode":"IE"},{"countryId":"13","countryName":"the Republic of Italy","countryCode":"IT"},{"countryId":"14","countryName":"Latvia","countryCode":"LV"},{"countryId":"15","countryName":"Lithuania","countryCode":"LT"},{"countryId":"16","countryName":"the Great Duchy of Luxembourg","countryCode":"LU"},{"countryId":"17","countryName":"Hungari","countryCode":"HU"},{"countryId":"18","countryName":"Malta","countryCode":"MT"},{"countryId":"19","countryName":"The Netherlands","countryCode":"NL"},{"countryId":"20","countryName":"Federal Republic of Germany","countryCode":"DE"},{"countryId":"21","countryName":"Republic of Poland","countryCode":"PL"},{"countryId":"22","countryName":"Portugal","countryCode":"PT"},{"countryId":"23","countryName":"Romania","countryCode":"RO"},{"countryId":"24","countryName":"Slovakia","countryCode":"SK"},{"countryId":"25","countryName":"Slovenia","countryCode":"SI"},{"countryId":"26","countryName":"Spain","countryCode":"ES"},{"countryId":"27","countryName":"Sweden","countryCode":"SE"},{"countryId":"28","countryName":"Island","countryCode":"IS"},{"countryId":"29","countryName":"Norway","countryCode":"NO"},{"countryId":"30","countryName":"Switzerland","countryCode":"CH"},{"countryId":"31","countryName":"United Kingdom of the Great Britain and Northern Ireland","countryCode":"GB"},{"countryId":"32","countryName":"Belarus","countryCode":"BY"},{"countryId":"33","countryName":"Moldova","countryCode":"MD"},{"countryId":"34","countryName":"Russian Federation","countryCode":"RU"},{"countryId":"35","countryName":"Ukraine","countryCode":"UA"},{"countryId":"36","countryName":"Armenia","countryCode":"AM"},{"countryId":"37","countryName":"Azerbajd\u017ean","countryCode":"AZ"},{"countryId":"38","countryName":"Gruzija","countryCode":"GE"},{"countryId":"39","countryName":"Principality of Andorra","countryCode":"AD"},{"countryId":"40","countryName":"Liechtenstein","countryCode":"LI"},{"countryId":"41","countryName":"Monaco","countryCode":"MC"},{"countryId":"42","countryName":"San Marino","countryCode":"SM"},{"countryId":"43","countryName":"Vatikan City","countryCode":"VA"},{"countryId":"44","countryName":"the Republic of Albania","countryCode":"AL"},{"countryId":"45","countryName":"Bosnia and Herzegovina","countryCode":"BA"},{"countryId":"46","countryName":"Montenegro","countryCode":"ME"},{"countryId":"47","countryName":"Republic of Kosovo","countryCode":"XK"},{"countryId":"48","countryName":"The Republic of North Macedonia","countryCode":"MK"},{"countryId":"49","countryName":"The Republic of Srbia","countryCode":"RS"},{"countryId":"50","countryName":"Turkey","countryCode":"TR"}];
		for (let i = 0; i < countryList.length; i++)
			if (countryList[i].countryCode == code)
				return countryList[i].countryId;
	}

	//	Registration submission
	const onSubmit = (data: IUser) => {
		if (countryCode) {
			let workArea = sessionStorage.getItem("register_userWorkSubArea") || "";

			if ((data != null || data != undefined) && agreeButton) {
				data = { ...data, "fk_userWorkSubArea": workArea };
				data = { ...data, "fk_countryList": countryCodeID(countryCode) };

				registerUser(data).then(function() {
					sessionStorage.removeItem("register_userWorkSubArea");
				});
			};
		} else {
			setCountryCodeModal(true);
		}
	};

	//	List of countries included in the dropdown menu
	const countries = ["AL","AD","AM","AT","AZ","BY","BE","BA","BG","HR","CY","CZ","DK","EE","FI","FR","GE","DE","GR","HU","IS","IE","IT","XK","LV","LI","LT","LU","MT","MD","MC","ME","NL","MK","NO","PL","PT","RO","RU","SM","RS","SK","SI","ES","SE","CH","TR","UA","GB","VA"];

	//	Checkbox handling
	const userAgreed = () => {
		if (!agreeButton) {
			setAgreeButton(true);
		}
		if (agreeButton) {
			setAgreeButton(false);
		}
	};
	
	//	POST /register
	const registerUser = async (user: IUser) => {
		const response = await authStore?.registerUser(user);
		if (response === "OK") {
			history.push("/login");
		} else {
			setMessage(response.data);
		}
	};
	
	useEffect(() => {
		const userWorkArea = async () => {
			await institutionStore?.getCodeList();
			setFetched(true);
		};
		userWorkArea();
	}, [institutionStore, authStore]);

	const workAreaUpdate = (workArea: any) => {
		setWorkArea(workArea);
	}

	return (
		<AuthProvider>
			<Container component="main" maxWidth="xs" style={{ marginBottom: "48px", }}>
				<CssBaseline />
				<div className={classes.paper}>
					<Avatar className={classes.avatar}>
						<LockOutlinedIcon />
					</Avatar>
					<Typography component="h1" variant="h5">
						Sign up
					</Typography>
					<form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
						<Grid container spacing={2} style={{ marginBottom: "12px", }}>
							<Grid item xs={12} sm={6}>
								<TextField
									autoComplete="first"
									inputRef={register({ required: true })}
									name="firstName"
									variant="outlined"
									required
									fullWidth
									id="firstName"
									label="First name"
									autoFocus
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									variant="outlined"
									inputRef={register({ required: true })}
									required
									fullWidth
									id="lastName"
									label="Last name"
									name="lastName"
									autoComplete="lname"
								/>
							</Grid>
							<Grid item md={12} lg={12} xs={12}>
								<FormControl variant="outlined" fullWidth>
									<InputLabel htmlFor="outlined-age-native-simple">Gender</InputLabel>
									<Select
										native
										fullWidth
										inputRef={register({ required: true })}
										label="Gender"
										inputProps={{
											name: "genderISOIEC5218",
											id: "outlined-age-native-simple",
										}}
									>
										<option value={1}>Male</option>
										<option value={2}>Female</option>
									</Select>
								</FormControl>
							</Grid>							
							<Grid item xs={12}>
								<ReactFlagsSelect
									id="fk_countryList"
									countries={countries}
									selected={countryCode}
									onSelect={(code: any) => setCountryCode(code)}
								/>
							</Grid>
							<Grid item xs={12}>
								<TextField
									variant="outlined"
									inputRef={register({ required: true })}
									required
									fullWidth
									error={message !== ""}
									helperText={message}
									id="email"
									label="E-mail address"
									name="email"
									autoComplete="email"
								/>
							</Grid>
							<Grid item xs={12}>
								<TextField
									variant="outlined"
									required
									fullWidth
									inputRef={register({ required: true })}
									name="password"
									label="Password"
									type="password"
									id="password"
									autoComplete="current-password"
								/>
							</Grid>
							<Grid item md={workArea != 39 ? 12 : 6} lg={workArea != 39 ? 12 : 6} xs={workArea != 39 ? 12 : 6}>
								<WorkArea userworkarea={institutionStore?.institution?.userworkarea} workAreaUpdate={workAreaUpdate} />
							</Grid>
							<Grid item xs={6} style={{ display: workArea != 39 ? "none" : "inherit" }}>
								<TextField
									variant="outlined"
									inputRef={register({ required: workArea == 39 ? true : false })}
									fullWidth
									required={workArea == 39 ? true : false}
									id="workAreaOther"
									label="Work area"
									name="workAreaOther"
									autoComplete="workAreaOther"
								/>
							</Grid>
							<Grid item xs={12}>
								<TextField
									variant="outlined"
									inputRef={register({ required: true })}
									required
									fullWidth
									id="titleOfTheInstitution"
									label="Institution"
									name="titleOfTheInstitution"
									autoComplete="titleOfTheInstitution"
								/>
							</Grid>
							<Grid item xs={12}>
								<FormControlLabel
									control={
										<Checkbox
											checked={agreeButton}
											onClick={userAgreed}
											value="agree"
											color="primary"
											name="terms"
											className="hejde-register-label"
											inputRef={register({ required: true })}
										/>
									}
									label={`By clicking on the Sign up button below, you agree with our Terms of Use and confirm to have read our Data Use policy.`}
								/>
							</Grid>
							<Grid item xs={12}>
								<FormControlLabel
									control={
										<Checkbox
											checked={personalData}
											onClick={() => setPersonalData(!personalData)}
											value="agree"
											color="primary"
											name="terms"
											className="hejde-register-label"
											inputRef={register({ required: true })}
										/>
									}
									label={`For the purpose of the HEJDE project activity "Mapping the European higher education of journalists", all personal data of the HEJDE project collaborators will be collected and used in accordance with GDPR's privacy and security requirements, while sociodemographic data will be only used anonymously and in general for the purpose of the scientific research .`}
								/>
							</Grid>
							<Grid item xs={12}>
								<FormControlLabel
									control={
										<Checkbox
											checked={affiliation}
											onClick={() => setAffiliation(!affiliation)}
											value="agree"
											color="primary"
											name="terms"
											className="hejde-register-label"
											inputRef={register({ required: true })}
										/>
									}
									label={`I agree that my name, surname and affiliation is published in the public list of collaborators of the HEJDE project activity "Mapping the European higher education of journalists" as a part of the interactive digital application.`}
								/>
							</Grid>
						</Grid>

						<Button type="submit" disabled={!(agreeButton && personalData && affiliation)} fullWidth variant="contained" color="primary" className={classes.submit}>
							Sign Up
						</Button>
						<Grid item xs={12}>
							{" "}
							<Grid item>
								<Link href="/login" variant="body2">
									Already have an account? Sign in
								</Link>
							</Grid>
						</Grid>
					</form>
				</div>

				<Snackbar open={countryCodeModal} autoHideDuration={6000} onClose={() => { setCountryCodeModal(false); }}>
					<Alert onClose={() => { setCountryCodeModal(false); }} severity="error">
						Please select a country.
					</Alert>
				</Snackbar>
			</Container>
		</AuthProvider>
	);
};
export default Register;
